<template>
  <div id="graphic-static">
    <div class="ipub-h1 mar-b-30">Graphic Statistics</div>
    <site-tab class="mar-b-30"
              :menus="menus" />
    <router-view></router-view>
  </div>
</template>
<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
